import { render, staticRenderFns } from "./MoleculeModalDiscoveryCredential.vue?vue&type=template&id=1e54a819&scoped=true&"
import script from "./MoleculeModalDiscoveryCredential.vue?vue&type=script&lang=js&"
export * from "./MoleculeModalDiscoveryCredential.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeModalDiscoveryCredential.vue?vue&type=style&index=0&id=1e54a819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54a819",
  null
  
)

export default component.exports